"use client";

import type { RefObject } from "react";
import type { Swiper as SwiperType } from "swiper";

import { ArrowLeftIcon } from "../icons/arrowLeft.icon";
import { ArrowRightIcon } from "../icons/arrowRight.icon";

export function CarouselCenteredNavButton({
  swiperRef,
  direction,
}: CarouselCenteredNavButtonProps) {
  const isPrev = direction === "prev";
  return (
    <button
      type="button"
      onClick={() =>
        isPrev ? swiperRef.current?.slidePrev() : swiperRef.current?.slideNext()
      }
      className="border-secondary text-secondary focus-visible:ring-secondary flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-full border transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none lg:min-h-10 lg:min-w-10"
      aria-label={isPrev ? "Previous slide" : "Next slide"}>
      {isPrev ? (
        <ArrowLeftIcon width={24} height={24} aria-hidden />
      ) : (
        <ArrowRightIcon width={24} height={24} aria-hidden />
      )}
    </button>
  );
}

export type CarouselCenteredNavButtonProps = {
  swiperRef: RefObject<SwiperType | null>;
  direction: "prev" | "next";
};
